import { useGet } from '@hox/frontend-utils/hooks/useFetch';
import { ILoginInfo } from '../models';
import { LOGIN_INFO_PATH } from '../constants';

const buildLoginInfoQueryString = (email: string) =>
  new URLSearchParams({ email }).toString();

export const useLoginInfo = (email: string | void) => {
  const pathAndQuery = `${LOGIN_INFO_PATH}?${buildLoginInfoQueryString(
    email || ''
  )}`;
  const [getResult] = useGet<ILoginInfo>(pathAndQuery, { skip: !email });
  return getResult;
};
